import {configureStore} from "@reduxjs/toolkit";
import authReducer from "../feature/auth/authSlice";
import {authApi} from "../services/auth";
import {persistAuthMiddleware} from "../feature/auth/persistAuthMiddleware";

import templateReducer from "../feature/templates/templateSlice"; // your slice
import {templatesApi} from "../services/templates";
import {emailListApi} from "../services/emailListApi";
import {tasksListApi} from "../services/tasks";
import {settingsApi} from "../services/settings";

import logger  from "redux-logger";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    templates: templateReducer,
    [authApi.reducerPath]: authApi.reducer,
    [templatesApi.reducerPath]: templatesApi.reducer,
    [emailListApi.reducerPath]: emailListApi.reducer,
    [tasksListApi.reducerPath]: tasksListApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,

  },
  middleware: (gdm) =>
    gdm().concat(authApi.middleware,
      templatesApi.middleware,
      emailListApi.middleware,
      tasksListApi.middleware,
      settingsApi.middleware,
      persistAuthMiddleware,logger)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
